import { render, staticRenderFns } from "./FrsProductPicker.vue?vue&type=template&id=45d940da&lang=html&"
import script from "./FrsProductPicker.vue?vue&type=script&lang=js&"
export * from "./FrsProductPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports